import Grade from "Common/Grade/Grade";
import React, { ReactElement } from "react";

export const useGetGradeHtml = (grade: string | undefined) : ReactElement => {
    return grade ? <Grade grade={grade} /> : <></>;
}